<template>
	<div>
		<ftp-items :records="records" :account="account" v-on:update-list="updateList" :loading.sync="loading" :savesStatus="savesStatus"></ftp-items>
		<ftp-create :records="records" :account="account"  v-on:update-list="updateList" :loading.sync="loading" :savesStatus="savesStatus"></ftp-create>
	</div>
</template>

<script>
	import {db} from "@/firebase/init";
	import swal from "sweetalert2";
	import _ from "lodash";
	import uuidv1 from "uuid/v1";

	import refreshToken from "../../../../../mixins/refreshTokenMixin";

	export default {
		name: "FtpList",
		mixins: [refreshToken],
		props: {
			account: {
				type: Object,
				required: true
			},
			envType: {
				type: String,
				required: true
			}
		},
		components: {
			FtpCreate: () =>
				import(/* webpackChunkName: "FtpCreate" */ "./FtpCreate"),
			FtpItems: () =>
				import(/* webpackChunkName: "FtpItems" */ "./FtpItems"),
		},
		data: function () {
			return {
				file: '',
				records: [],
				loading: false,
				savesStatus: false,
				domain: null
			}
		},
		watch: {
			account: {
				handler: function(value){
					const {ftp, domain} = value;
					this.domain = domain;
					this.records = [];

					if (ftp.accounts !== undefined) {
						this.records = Array.isArray(ftp.accounts) ? _.filter(ftp.accounts, item=>item.id!==undefined) : [];
						if(!this.records.length){
							if (ftp.username) {
								this.records.push({
									id: uuidv1(),
									username: ftp.username,
									password: ftp.password,
									primary: true
								});
							}
						} else {
						  const mainAcc = this.records.find((rec=>{
                return rec.username === ftp.username
              }))
						  if (!mainAcc) {
						    const obj = {
                  id: uuidv1(),
                  username: ftp.username,
                  password: ftp.password,
                  primary: true
                }
                this.records.splice(0, 0, obj)
              }
            }
					} else {
						if (ftp.username) {
							this.records.push({
								id: uuidv1(),
								username: ftp.username,
								password: ftp.password,
								primary: true
							});
						}
					}

                },
				immediate: true,
				deep: true
			}
		},
		computed: {
			accounts() {
				return this.$store.getters["hosting/accounts"];
			},
			clientID() {
				return this.$store.getters.getCustomerID;
			},
			userToken() {
				return this.$store.getters.getUserToken;
			},
			user() {
				return this.$store.getters.user;
			},
			requestUserId(){
				return this.$store.getters.requestUserId;
			},
			asyncDone() {
				return this.$store.getters["async/state"];
			}
		},
		methods: {
			updateList(records, message){
				this.saveToDb(records, message);
			},
			updateLoading(value){
				this.loading = value;
			},
			saveToDb(records, message) {
				let accounts = this.accounts;
				accounts = accounts.map((account) => {
          account.addon = _.map(account.addon, (addon) => {
            if (addon.domain === this.domain) {
              addon.ftp.accounts = records;
            } else if (addon.staging.domain === this.domain) {
              addon.staging.ftp.accounts = records;
            }
            return addon;
          });
					if (account.primary.domain === this.domain) {
            account.primary.ftp.accounts = records;
          } else if (account.primary.staging.domain === this.domain) {
            account.primary.staging.ftp.accounts = records;
          }
					return account;
				});

				return db
					.collection("hostingAccounts")
					.doc(this.requestUserId)
					.set({
						accounts: accounts
					})
					.then(() => {
						this.records = records;
						swal({
							title: "Success!",
							html: message,
							type: "success",
							confirmButtonText: "OK!",
							confirmButtonColor: "#EE8057"
						});
						this.addLog({
							name: this.user.firstName + " " + this.user.lastName,
							message: message,
							level: "info"
						});
						this.savesStatus = !this.savesStatus;
					}).catch( err =>{
						console.log(err);
					});
			}
		}
	};
</script>
